if (!customElements.get('lookbook-icon')) {
	class LookbookIcon extends HTMLElement {
		selectors = {
			cardProduct: '.f-lookbook-card__product',
			cardInner: '.f-lookbook-card__inner'
		}
		constructor() {
			super();

			this.domNodes = queryDomNodes(this.selectors, this)
			this.cardInner = this.closest(this.selectors.cardInner)
		}

		connectedCallback() {
			this.addEventListener('mouseover', this.init.bind(this))
		}
		disconnectedCallback() {
			this.removeEventListener('mouseover', this.init.bind(this))
		}

		init() {
			const { cardProduct } = this.domNodes
			this.cardInnerOffsetX = this.cardInner.getBoundingClientRect().left
			this.cardInnerOffsetY = this.cardInner.getBoundingClientRect().top

			this.offsetX = this.getBoundingClientRect().left - this.cardInnerOffsetX
			this.offsetY = this.getBoundingClientRect().top - this.cardInnerOffsetY

			this.cardProductWidth = cardProduct.clientWidth
			this.cardProductHeight = cardProduct.clientHeight
			this.cardInnerWidth = this.cardInner.clientWidth

			if (this.offsetX > this.cardProductWidth) {
				cardProduct.style.left = 'auto'
				cardProduct.style.right = 0
			} else {
				cardProduct.style.right = 'auto'
				if ((this.cardInnerWidth - this.offsetX) > this.cardProductWidth) {
					cardProduct.style.left = 0
				} else {
					cardProduct.style.left = this.cardInnerWidth - this.cardProductWidth - this.offsetX + 'px'
				}
			}

			if (this.offsetY > this.cardProductHeight) {
				cardProduct.style.top = 'auto'
				cardProduct.style.bottom = '100%'
			} else {
				cardProduct.style.bottom = 'auto'
				cardProduct.style.top = '100%'
			}
		}
	}
	customElements.define('lookbook-icon', LookbookIcon);
}
